
'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const API_BASE_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL;

// List of paths to exclude from analytics logging
const excludedPaths = [
    '/admin', // Exclude all admin paths
    '/api/',
    '/_next/',
    '/favicon.ico',
    '/grid.svg',
];

// List of file extensions to exclude
const excludedExtensions = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.svg',
];

function AnalyticsTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Determine if the path should be logged
    const startsWithExcluded = excludedPaths.some(path => pathname.startsWith(path));
    const endsWithExcluded = excludedExtensions.some(ext => pathname.endsWith(ext));
    
    if (!startsWithExcluded && !endsWithExcluded) {
      // Fire-and-forget the fetch call to the backend
      // The backend will extract IP, user-agent, etc., from the request headers
      fetch(`${API_BASE_URL}/api/analytics/visit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ pathname }),
        // Keepalive is important for fire-and-forget requests that might be sent when the user is navigating away
        keepalive: true,
      }).catch(error => {
        // We can silently fail here as analytics is not critical to user experience
        // console.error('[Analytics] Failed to log visit:', error);
      });
    }
  }, [pathname]); // Re-run the effect when the pathname changes

  return null; // This component does not render anything
}

export default AnalyticsTracker;
